<template>
  <el-drawer
    title="脑图"
    :visible.sync="visible"
    direction="btt"
    size="72%"
    :wrapperClosable="true"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    :append-to-body="false"
    @close="closeDrawer"
    @open="drawerOpenHandle"
  >
    <div class="dialog-content">
      <div class="button-list" v-if="activeData.data">
        <!-- <el-button type="primary" @click="$emit('toLocation', activeData.data.id)">跳转</el-button> -->
        <!-- <el-button type="primary" size="mini" @click="$emit('deleteMind', activeData.data.id)">移除</el-button> -->
        <!-- <el-button type="primary" size="mini" @click="$emit('deleteMind', activeData.data.id)">增加子节点</el-button> -->
        <el-button type="primary" size="mini" @click="deleteMind(activeData.data.id)">移除</el-button>
        <el-button v-if="activeData.data.isRoot != 1" type="primary" size="mini" @click="addMind">增加兄弟节点</el-button>
        <el-button type="primary" size="mini" @click="addChildMind">增加子节点</el-button>
      </div>
      <div id="mindMapContainer"></div>
      <div class="mind-map-bottom">
        <el-button type="text" @click.stop="resetLayout">
          <span class="icon el-icon-aim"></span>
        </el-button>
        <el-button type="text" @click.stop="exportImage">
          <span class="icon el-icon-download"></span>
        </el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { getMindMap, setMindMap } from "@/utils/storage";
import MindMap from 'simple-mind-map'
import MiniMap from 'simple-mind-map/src/plugins/MiniMap.js'
import Watermark from 'simple-mind-map/src/plugins/Watermark.js'
import KeyboardNavigation from 'simple-mind-map/src/plugins/KeyboardNavigation.js'
import ExportPDF from 'simple-mind-map/src/plugins/ExportPDF.js'
import ExportXMind from 'simple-mind-map/src/plugins/ExportXMind.js'
import Export from 'simple-mind-map/src/plugins/Export.js'
import Drag from 'simple-mind-map/src/plugins/Drag.js'
import Select from 'simple-mind-map/src/plugins/Select.js'
import AssociativeLine from 'simple-mind-map/src/plugins/AssociativeLine.js'
import TouchEvent from 'simple-mind-map/src/plugins/TouchEvent.js'
import NodeImgAdjust from 'simple-mind-map/src/plugins/NodeImgAdjust.js'
import SearchPlugin from 'simple-mind-map/src/plugins/Search.js'
import Painter from 'simple-mind-map/src/plugins/Painter.js'
// import Formula from 'simple-mind-map/src/plugins/Formula.js'
import RainbowLines from 'simple-mind-map/src/plugins/RainbowLines.js'
import Demonstrate from 'simple-mind-map/src/plugins/Demonstrate.js'
import OuterFrame from 'simple-mind-map/src/plugins/OuterFrame.js'
// // 注册插件
MindMap.usePlugin(MiniMap)
  .usePlugin(Watermark)
  .usePlugin(Drag)
  .usePlugin(KeyboardNavigation)
  .usePlugin(ExportPDF)
  .usePlugin(ExportXMind)
  .usePlugin(Export)
  .usePlugin(Select)
  .usePlugin(AssociativeLine)
  .usePlugin(NodeImgAdjust)
  .usePlugin(TouchEvent)
  .usePlugin(SearchPlugin)
  .usePlugin(Painter)
  // .usePlugin(Formula)
  .usePlugin(RainbowLines)
  .usePlugin(Demonstrate)
  .usePlugin(OuterFrame)

export default {
  name: "mindMap",
  props: {
    mindMapVisible: {
      type: Boolean,
      default: false
    },
    mindMapData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      visible: false,
      mindMap: null,
      activeData: {},
      editId: ''
    }
  },
  watch: {
    mindMapVisible(newVal) {
      this.visible = newVal
    }
  },
  mounted() {
  },
  methods: {
    drawerOpenHandle() {
      this.$nextTick(() => {
        let data = JSON.parse(JSON.stringify(this.mindMapData));
        let _this = this;
        if(!this.mindMap) {
          // 创建脑图
          this.mindMap = new MindMap({
            el: document.getElementById('mindMapContainer'),
            data,
            fitPadding: 20,
            exportPaddingX: 20,
            exportPaddingY: 50,
            isLimitMindMapInCanvas: true,
            isUseCustomNodeContent: false,
          });
          this.mindMap.on('draw_click', () => {
            this.activeData = {}
          })
          // 激活操作脑图内容
          this.mindMap.on('node_active', (that, e) => {
            if(that) {
              this.activeData = that.nodeData
            }else{
              this.activeData = {}
              this.mindMap.execCommand('CLEAR_ACTIVE_NODE')
            }
          })
          // 节点树渲染完毕 自适应显示整体脑图
          this.mindMap.on('node_tree_render_end', () => {
            this.mindMap.view.fit()
          })
          // this.mindMap.on('hide_text_edit', () => {
          //   this.updateData()
          // })
          this.mindMap.on('data_change', () => {
            this.updateData()
          })
        }else{
          this.mindMap.updateData(data)
          this.activeData = {}
          this.editId = ''
        }
      })
    },
    updateMindMap() {
      if(this.mindMap) {
        this.mindMap.updateData(this.mindMapData)
      }
    },
    closeDrawer() {
      this.mindMap.execCommand('CLEAR_ACTIVE_NODE')
      this.$emit('closeDrawer')
    },
    deleteMind() {
      this.mindMap.execCommand('REMOVE_NODE')
      this.mindMap.execCommand('CLEAR_ACTIVE_NODE')
      this.updateData()
    },
    addMind() {
      this.mindMap.execCommand('INSERT_NODE')
      this.updateData()
    },
    addChildMind() {
      this.mindMap.execCommand('INSERT_CHILD_NODE')
      this.updateData()
    },
    resetLayout() {
      this.mindMap.execCommand('RESET_LAYOUT')
    },
    exportImage() {
      this.mindMap.doExport.export('png', false).then((res) => {
        const filename = '思维导图.png'
        if(this.device.isMobile && this.device.isApp) {
          if(this.device.isIos) {
            if (window.webkit) {
              window.webkit.messageHandlers.jsCallOCFunction.postMessage({
                type: -14,
                imgName: filename,
                img: res
              });
            }
          }else{
            window.Android.HtmlToAndroid(JSON.stringify({
              type: -14,
              imgName: filename,
              img: res
            }));
          }
        }else{
          let blob = this.base64ToBlob(res)  // 转码
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          document.body.appendChild(a)
          a.href = url
          a.target = "_blank"
          a.download = filename
          a.click();
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }
      }).catch(err => {
        console.log(err)
      })
      // this.mindMap.doExport.png().then((res) => {
      //   console.log('res', res)
      // }).catch(err => {
      //   console.log('err', err)
      // })
    },
    updateData() {
      setMindMap(JSON.stringify(this.mindMap.getData()))
      this.$emit('mindMapUpdate', this.mindMap.getData())
    },
    base64ToBlob (code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;
      let uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new window.Blob([uInt8Array], {type: contentType});
    },
    base64ToFile(base64Data, filename) {
      // 将base64的数据部分提取出来
      const parts = base64Data.split(';base64,');
      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      
      // 将原始数据转换为Uint8Array
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      
      // 使用Blob和File构造函数创建文件
      const blob = new Blob([uInt8Array], {type: contentType});
      const file = new File([blob], filename, {type: contentType});
      
      return file;
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-content{
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .button-list{
    position: absolute;
    top: 0;
    left: 0;
  }

  #mindMapContainer{
    width: 100%;
    height: 100%;
    overflow: hidden;

    /deep/.mind-map-item{
      padding: 5rem 10rem;
      font-size: 16rem;
      line-height: 24rem;
      max-width: 500rem;
      border: 1rem solid rgb(84, 150, 136);
      border-radius: 3rem;
      user-select: text;

      .mind-map-item-selected{
        padding: 10rem 16rem;
        background: #f1f1f1;
        border: 1rem dashed #4f678e;
        border-radius: 2rem;
      }
    }

    /deep/.mind-map-item-main{
      color: #fff;
      font-weight: bold;
      background: rgb(84, 150, 136);
    }
  }

  .mind-map-bottom{
    position: absolute;
    bottom: 40rem;
    right: 40rem;
    padding: 10rem;

    .icon{
      font-size: 40rem;
    }
  }
}
/deep/.el-drawer__wrapper{
  z-index: 2999;
}
/deep/.el-drawer{
  border-radius: 20rem 20rem 0 0;

  .el-drawer__header{
    padding: 0 42rem 0 32rem;
    margin: 0;

    span{
      font-size: 36rem;
      color: #333;
      font-weight: bold;
      line-height: 112rem;
    }

    .el-drawer__close-btn{
      font-size: 36rem;
    }
  }
}
</style>